var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{tag:"component",class:_vm.getThemeClass('nav'),attrs:{"aria-label":_vm.ariaLabel}},[_vm._l((_vm.items),function(navItem,index){return _vm._t("default",function(){return [_c(_vm.navItemType,{tag:"component",class:_vm.getThemeClass('navItem'),attrs:{"link-to":_vm.$sbutils.linkTo(navItem),"tag":_vm.$sbutils.tag(navItem),"label":_vm.$sbutils.label(navItem)}})]},null,{
      index: index,
      linkTo: _vm.$sbutils.linkTo(navItem),
      tag: _vm.$sbutils.tag(navItem),
      label: _vm.$sbutils.label(navItem),
      navItem: navItem
    })})],2)}
var staticRenderFns = []

export { render, staticRenderFns }